<template>
    <div class="c-faq-accordion">
        <div
            class="accordion-item"
            @click="expand = !expand"
        >
            <div class="accordion-item__header">
                <div class="accordion-question">
                    <span class="question-number">{{ questionNumber }}</span>
                    <component
                        :is="titleTag || 'h4'"
                        class="title"
                    >
                        {{ item.title }}
                    </component>
                </div>

                <img
                    src="@/modules/mvp/assets/expand-more.svg"
                    :alt="$t('mvp.icon_alt')"
                    class="mvp-faq-img"
                    :class="{'rotate-expand-svg': expand}"
                >
            </div>

            <div
                v-smooth-height="expand"
                class="accordion-item__body"
            >
                <p v-html="item.text" />
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name      : 'FaqAccordion',
        /**
         *
         * @inheritDoc
         */
        directives: {
            /**
             * @inheritDoc
             */
            smoothHeight: {
                /**
                 * @inheritDoc
                 */
                inserted(el) {
                    // eslint-disable-next-line no-param-reassign
                    el.style.transition = 'all 0.3s ease-in-out';
                    // eslint-disable-next-line no-param-reassign
                    el.style.height = '0px';
                },

                /**
                 * @inheritDoc
                 */
                update(el, binding) {
                    if (binding.value) {
                        // eslint-disable-next-line no-param-reassign
                        el.style.height = `${el.scrollHeight}px`;
                    } else {
                        // eslint-disable-next-line no-param-reassign
                        el.style.height = '0px';
                    }
                },

            },
        },
        props: {
            item: {
                type    : Object,
                required: true,
            },
            number: {
                type: Number,
            },
            titleTag: {
                type: String,
            },

        },
        /**
         *
         * @inheritDoc
         */
        data() {
            return { expand: false };
        },

        /**
         *
         * @inheritDoc
         */
        computed: {
            /**
             * Question number
             *
             * @returns {string}
             */
            questionNumber() {
                return `${this.number + 1}.`;
            },

        },

    };
</script>

<style lang="scss" src="./index.scss"></style>
